const editGamedayModalStyles = (theme) => ({
  dialogField: {
    marginBottom: theme.spacing(2),
  },
})

export default editGamedayModalStyles
